import React, { useState, useMemo } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MemberDirectory = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');

  const members = [
    {
      id: 1,
      name: "Amara Jayasinghe",
      profession: "Data Scientist",
      company: "Virtusa",
      joinYear: 2023,
      role: "Project Coordinator",
      industry: "Technology",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300&h=300&fit=crop&crop=face",
      serviceInterests: ["Education", "Technology"],
      achievements: ["Led coding bootcamp for 50+ students", "Organized tech career fair"],
      email: "amara.jayasinghe@email.com",
      linkedin: "linkedin.com/in/amarajayasinghe"
    },
    {
      id: 2,
      name: "Dinesh Rathnayake",
      profession: "Civil Engineer",
      company: "Access Engineering",
      joinYear: 2022,
      role: "Community Service Chair",
      industry: "Engineering",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300&h=300&fit=crop&crop=face",
      serviceInterests: ["Infrastructure", "Environment"],
      achievements: ["Built 3 community playgrounds", "Water conservation project leader"],
      email: "dinesh.rathnayake@email.com",
      linkedin: "linkedin.com/in/dineshrathnayake"
    },
    {
      id: 3,
      name: "Priyanka Mendis",
      profession: "Marketing Executive",
      company: "Unilever Sri Lanka",
      joinYear: 2021,
      role: "Public Relations Officer",
      industry: "Marketing",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=300&h=300&fit=crop&crop=face",
      serviceInterests: ["Women Empowerment", "Health"],
      achievements: ["Launched women\'s entrepreneurship program", "Organized health awareness campaigns"],
      email: "priyanka.mendis@email.com",
      linkedin: "linkedin.com/in/priyankamendis"
    },
    {
      id: 4,
      name: "Kasun Perera",
      profession: "Financial Advisor",
      company: "DFCC Bank",
      joinYear: 2023,
      role: "Fundraising Committee",
      industry: "Finance",
      image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=300&h=300&fit=crop&crop=face",
      serviceInterests: ["Financial Literacy", "Youth Development"],
      achievements: ["Conducted financial literacy workshops", "Raised LKR 500K for scholarships"],
      email: "kasun.perera@email.com",
      linkedin: "linkedin.com/in/kasunperera"
    },
    {
      id: 5,
      name: "Nimesha Silva",
      profession: "Graphic Designer",
      company: "Freelancer",
      joinYear: 2022,
      role: "Creative Director",
      industry: "Design",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=300&h=300&fit=crop&crop=face",
      serviceInterests: ["Arts", "Education"],
      achievements: ["Designed club\'s visual identity", "Art therapy program for children"],
      email: "nimesha.silva@email.com",
      linkedin: "linkedin.com/in/nimeshasilva"
    },
    {
      id: 6,
      name: "Ruwan Fernando",
      profession: "Doctor",
      company: "National Hospital",
      joinYear: 2021,
      role: "Health Committee Chair",
      industry: "Healthcare",
      image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=300&h=300&fit=crop&crop=face",
      serviceInterests: ["Healthcare", "Community Wellness"],
      achievements: ["Free medical camps organizer", "COVID-19 awareness campaigns"],
      email: "ruwan.fernando@email.com",
      linkedin: "linkedin.com/in/ruwanfernando"
    },
    {
      id: 7,
      name: "Ishara Wickramasinghe",
      profession: "Teacher",
      company: "Royal College",
      joinYear: 2023,
      role: "Education Committee",
      industry: "Education",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&crop=face",
      serviceInterests: ["Education", "Youth Development"],
      achievements: ["Tutoring program for underprivileged", "Educational resource development"],
      email: "ishara.wickramasinghe@email.com",
      linkedin: "linkedin.com/in/isharawickramasinghe"
    },
    {
      id: 8,
      name: "Chamari Rajapaksa",
      profession: "HR Manager",
      company: "MAS Holdings",
      joinYear: 2022,
      role: "Membership Chair",
      industry: "Human Resources",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300&h=300&fit=crop&crop=face",
      serviceInterests: ["Professional Development", "Women Empowerment"],
      achievements: ["Career mentorship program", "Leadership training workshops"],
      email: "chamari.rajapaksa@email.com",
      linkedin: "linkedin.com/in/chamarirajapaksa"
    }
  ];

  const filterOptions = [
    { value: 'all', label: 'All Members', count: members.length },
    { value: 'Technology', label: 'Technology', count: members.filter(m => m.industry === 'Technology').length },
    { value: 'Healthcare', label: 'Healthcare', count: members.filter(m => m.industry === 'Healthcare').length },
    { value: 'Finance', label: 'Finance', count: members.filter(m => m.industry === 'Finance').length },
    { value: 'Education', label: 'Education', count: members.filter(m => m.industry === 'Education').length },
    { value: 'Engineering', label: 'Engineering', count: members.filter(m => m.industry === 'Engineering').length }
  ];

  const filteredMembers = useMemo(() => {
    let filtered = members;

    // Apply industry filter
    if (activeFilter !== 'all') {
      filtered = filtered.filter(member => member.industry === activeFilter);
    }

    // Apply search filter
    if (searchTerm) {
      filtered = filtered.filter(member =>
        member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        member.profession.toLowerCase().includes(searchTerm.toLowerCase()) ||
        member.company.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Apply sorting
    filtered.sort((a, b) => {
      switch (sortBy) {
        case 'name':
          return a.name.localeCompare(b.name);
        case 'joinYear':
          return b.joinYear - a.joinYear;
        case 'profession':
          return a.profession.localeCompare(b.profession);
        default:
          return 0;
      }
    });

    return filtered;
  }, [activeFilter, searchTerm, sortBy]);

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Member Directory
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Discover the diverse professionals who make up our Leo Circle community. 
            Filter by industry, search by name, or explore their contributions.
          </p>
        </div>

        {/* Search and Filter Controls */}
        <div className="mb-8 space-y-4 lg:space-y-0 lg:flex lg:items-center lg:justify-between">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="relative">
              <Icon name="Search" size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
              <input
                type="text"
                placeholder="Search members..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-smooth w-full sm:w-64"
              />
            </div>
            
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-smooth"
            >
              <option value="name">Sort by Name</option>
              <option value="joinYear">Sort by Join Year</option>
              <option value="profession">Sort by Profession</option>
            </select>
          </div>

          <div className="text-sm text-muted-foreground">
            Showing {filteredMembers.length} of {members.length} members
          </div>
        </div>

        {/* Filter Tabs */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-2">
            {filterOptions.map((option) => (
              <button
                key={option.value}
                onClick={() => setActiveFilter(option.value)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-smooth ${
                  activeFilter === option.value
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-primary/10 hover:text-primary'
                }`}
              >
                {option.label} ({option.count})
              </button>
            ))}
          </div>
        </div>

        {/* Members Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredMembers.map((member) => (
            <div key={member.id} className="bg-card rounded-xl card-shadow hover:card-shadow-hover transition-smooth overflow-hidden">
              <div className="relative">
                <div className="aspect-square overflow-hidden">
                  <Image
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover hover:scale-105 transition-smooth"
                  />
                </div>
                <div className="absolute top-3 right-3 bg-background/90 backdrop-blur-sm px-2 py-1 rounded-full text-xs font-medium text-foreground">
                  Since {member.joinYear}
                </div>
              </div>

              <div className="p-5">
                <h3 className="text-lg font-bold text-foreground mb-1">{member.name}</h3>
                <p className="text-primary font-medium text-sm mb-1">{member.profession}</p>
                <p className="text-muted-foreground text-sm mb-3">{member.company}</p>

                <div className="mb-3">
                  <span className="inline-block bg-accent/10 text-accent px-2 py-1 rounded-md text-xs font-medium">
                    {member.role}
                  </span>
                </div>

                <div className="mb-4">
                  <p className="text-xs font-medium text-foreground mb-2">Service Interests:</p>
                  <div className="flex flex-wrap gap-1">
                    {member.serviceInterests.map((interest, index) => (
                      <span
                        key={index}
                        className="px-2 py-1 bg-muted text-muted-foreground text-xs rounded-md"
                      >
                        {interest}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="mb-4">
                  <p className="text-xs font-medium text-foreground mb-2">Key Contributions:</p>
                  <ul className="space-y-1">
                    {member.achievements.slice(0, 2).map((achievement, index) => (
                      <li key={index} className="text-xs text-muted-foreground flex items-start">
                        <Icon name="CheckCircle" size={10} className="text-accent mr-2 mt-1 flex-shrink-0" />
                        {achievement}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="flex items-center justify-between pt-3 border-t border-border">
                  <div className="flex items-center space-x-2">
                    <a
                      href={`mailto:${member.email}`}
                      className="p-1.5 text-muted-foreground hover:text-primary transition-smooth"
                    >
                      <Icon name="Mail" size={14} />
                    </a>
                    <a
                      href={`https://${member.linkedin}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="p-1.5 text-muted-foreground hover:text-primary transition-smooth"
                    >
                      <Icon name="Linkedin" size={14} />
                    </a>
                  </div>
                  <Button variant="ghost" size="xs">
                    View Profile
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredMembers.length === 0 && (
          <div className="text-center py-12">
            <Icon name="Users" size={48} className="text-muted-foreground mx-auto mb-4" />
            <h3 className="text-lg font-medium text-foreground mb-2">No members found</h3>
            <p className="text-muted-foreground">Try adjusting your search or filter criteria.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default MemberDirectory;